import Index from '@/pages/Index.vue'

const home = [
  {
    path: '/',
    name: 'index',
    component: Index,
    redirect: '/home',
    meta: {
      keepAlive: []
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/pages/home/public-home.vue'),
        meta: {
          keepAlive: []
        }
      },
      {
        path: '/mall',
        name: 'mall',
        component: () => import(/* webpackChunkName: "mall" */ '@/pages/mall/mall.vue'),
        meta: {
          login: false,
          keepAlive: []
        }
      },
      {
        path: '/health',
        name: 'health',
        component: () => import(/* webpackChunkName: "mall" */ '@/pages/home/health.vue'),
        meta: {
          keepAlive: []
        }
      },
      {
        path: '/mine',
        name: 'mine',
        component: () => import(/* webpackChunkName: "mine" */ '@/pages/mine/mine.vue'),
        meta: {
          login: false,
          keepAlive: []
        }
      },
      {
        path: '/zhenai',
        name: 'zhenai',
        component: () => import(/* webpackChunkName: "project-agent" */ '@/pages/zhenai/index.vue'),
        meta: {
          login: false,
          title: '袋鼠健康'
        }
      },
      {
        path: '/pre-exam-platform',
        name: 'pre-exam-platform',
        component: () => import(/* webpackChunkName: "pre-exam-platform" */ '@/pages/home/pre-exam-home.vue'),
        meta: {
          login: false,
          title: '健康管理平台'
        }
      },
    ]
  },
  {
    path: '/physical-examination',
    name: 'physical-examination',
    component: () => import(/* webpackChunkName: "physicalExamination" */ '@/pages/home/physical-examination'),
    meta: {
      title: '健康体检'
    }
  }
]
export default home
